<!-- Backdrop -->
@if (isOpen) {
  <!-- Backdrop oscuro -->
  <div
    class="fixed inset-0 bg-black/30 z-40 transition-opacity duration-300"
    role="button"
    tabindex="0"
    (click)="onBackdropClick()"
    (keydown.escape)="onBackdropClick()"
    (keydown.enter)="onBackdropClick()"
  ></div>

  <!-- Sidebar Panel -->
  <aside
    class="fixed top-sidebar-top right-12 w-sidebar-panel h-sidebar-calc bg-white shadow-sidebar z-sidebar-sm flex flex-col gap-8 p-6 rounded-xl animate-slide-in-right md:right-4 md:w-full-mobile md:max-w-sidebar-panel"
    (click)="onSidebarClick($event)"
    (keydown.escape)="onClose()"
    aria-labelledby="sidebar-title"
    role="dialog"
    tabindex="-1"
  >
    <!-- Header -->
    <div class="flex justify-between items-center">
      <h3 id="sidebar-title" class="text-2xl font-semibold text-blue-300 m-0">
        Filtrar
      </h3>
    </div>

    <!-- Scrollable content -->
    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <!-- Prioridad Section -->
      @if (isFilterVisible('priority')) {
        <div class="filter-section">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="togglePriorityCollapse()"
            (keydown.enter)="togglePriorityCollapse()"
            (keydown.space)="togglePriorityCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">Prioridad</h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isPriorityCollapsed"
            ></i>
          </div>
          @if (!isPriorityCollapsed) {
            <div class="flex flex-col items-start gap-2">
              @for (priority of priorityOptions; track priority.id) {
                <app-checkbox-button
                  [label]="priority.name"
                  [checked]="isPrioritySelected(priority.id)"
                  (checkedChange)="onPriorityChange(priority.id, $event)"
                >
                </app-checkbox-button>
              }
            </div>
          }
        </div>
      }

      <!-- Causa de Reproceso Section -->
      @if (isFilterVisible('reprocessCause')) {
        <div class="filter-section pt-6">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="toggleReprocessCauseCollapse()"
            (keydown.enter)="toggleReprocessCauseCollapse()"
            (keydown.space)="toggleReprocessCauseCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">
              Causa de reproceso
            </h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isReprocessCauseCollapsed"
            ></i>
          </div>
          @if (!isReprocessCauseCollapsed) {
            @if (loadingOptions) {
              <div class="flex items-center justify-center py-4">
                <span class="text-sm text-gray-500">Cargando opciones...</span>
              </div>
            }
            @if (optionsError) {
              <div class="text-sm text-error-DEFAULT py-2">
                {{ optionsError }}
              </div>
            }
            @if (!loadingOptions && !optionsError) {
              <div class="flex flex-col items-start gap-2">
                @for (cause of availableReprocessCauses; track cause.id) {
                  <app-checkbox-button
                    [label]="cause.name"
                    [checked]="isReprocessCauseSelected(cause.id)"
                    (checkedChange)="onReprocessCauseChange(cause.id, $event)"
                  >
                  </app-checkbox-button>
                }
              </div>
            }
          }
        </div>
      }

      <!-- Regional Section -->
      @if (isFilterVisible('region')) {
        <div class="filter-section pt-6">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="toggleRegionCollapse()"
            (keydown.enter)="toggleRegionCollapse()"
            (keydown.space)="toggleRegionCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">Regional</h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isRegionCollapsed"
            ></i>
          </div>
          @if (!isRegionCollapsed) {
            @if (loadingOptions) {
              <div class="flex items-center justify-center py-4">
                <span class="text-sm text-gray-500">Cargando opciones...</span>
              </div>
            }
            @if (optionsError) {
              <div class="text-sm text-error-DEFAULT py-2">
                {{ optionsError }}
              </div>
            }
            @if (!loadingOptions && !optionsError) {
              <div class="flex flex-col items-start gap-2">
                @for (region of availableRegions; track region) {
                  <app-checkbox-button
                    [label]="region.name"
                    [checked]="isRegionSelected(region.id)"
                    (checkedChange)="onRegionChange(region.id, $event)"
                  >
                  </app-checkbox-button>
                }
              </div>
            }
          }
        </div>
      }

      <!-- Sede Section (Multiselect) -->
      @if (isFilterVisible('site')) {
        <div class="filter-section pt-6">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="toggleSiteCollapse()"
            (keydown.enter)="toggleSiteCollapse()"
            (keydown.space)="toggleSiteCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">Sede</h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isSiteCollapsed"
            ></i>
          </div>
          @if (!isSiteCollapsed) {
            @if (!loadingOptions && !optionsError) {
              <div class="flex flex-col items-start gap-2">
                @for (site of availableSites; track site.id) {
                  <app-checkbox-button
                    [label]="site.name"
                    [checked]="isSiteSelected(site.id)"
                    (checkedChange)="onSiteChange(site.id, $event)"
                  >
                  </app-checkbox-button>
                }
              </div>
            }
          }
        </div>
      }

      <!-- Tipo de examen Section -->
      @if (isFilterVisible('examType')) {
        <div class="filter-section pt-6">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="toggleExamTypeCollapse()"
            (keydown.enter)="toggleExamTypeCollapse()"
            (keydown.space)="toggleExamTypeCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">
              Tipo de examen
            </h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isExamTypeCollapsed"
            ></i>
          </div>
          @if (!isExamTypeCollapsed) {
            @if (!loadingOptions && !optionsError) {
              <div class="flex flex-col items-start gap-2">
                @for (examType of availableExamTypes; track examType.code) {
                  <app-checkbox-button
                    [label]="examType.name"
                    [checked]="isExamTypeSelected(examType.code)"
                    (checkedChange)="onExamTypeChange(examType.code, $event)"
                  >
                  </app-checkbox-button>
                }
              </div>
            }
          }
        </div>
      }

      <!-- Estado de muestra Section -->
      @if (isFilterVisible('sampleStatus')) {
      <div class="filter-section pt-6">
        <div
          class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
          role="button"
          tabindex="0"
          (click)="toggleSampleStatusCollapse()"
          (keydown.enter)="toggleSampleStatusCollapse()"
          (keydown.space)="toggleSampleStatusCollapse()"
        >
          <h6 class="text-xs font-semibold text-blue-300 m-0">
            Estado
          </h6>
          <i
            class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
            [class.rotate-180]="isSampleStatusCollapsed"
          ></i>
        </div>
        @if (!isSampleStatusCollapsed) {
          @if (!loadingOptions && !optionsError) {
            <div class="flex flex-col items-start gap-2">
              @for (status of availableSampleStatuses; track status.code) {
                <app-checkbox-button
                  [label]="status.name"
                  [checked]="isSampleStatusSelected(status.code)"
                  (checkedChange)="onSampleStatusChange(status.code, $event)"
                >
                </app-checkbox-button>
              }
            </div>
          }
        }
      </div>
      }

      <!-- Tipo de muestra Section -->
      @if (isFilterVisible('sampleType')) {
      <div class="filter-section pt-6">
        <div
          class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
          role="button"
          tabindex="0"
          (click)="toggleSampleTypeCollapse()"
          (keydown.enter)="toggleSampleTypeCollapse()"
          (keydown.space)="toggleSampleTypeCollapse()"
        >
          <h6 class="text-xs font-semibold text-blue-300 m-0">
            Tipo de muestra
          </h6>
          <i
            class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
            [class.rotate-180]="isSampleTypeCollapsed"
          ></i>
        </div>
        @if (!isSampleTypeCollapsed) {
          @if (!loadingOptions && !optionsError) {
            <div class="flex flex-col items-start gap-2">
              @for (sampleType of availableSampleTypes; track sampleType.code) {
                <app-checkbox-button
                  [label]="sampleType.name"
                  [checked]="isSampleTypeSelected(sampleType.code)"
                  (checkedChange)="onSampleTypeChange(sampleType.code, $event)"
                >
                </app-checkbox-button>
              }
            </div>
          }
        }
      </div>
      }

      <!-- Ciudad Ingreso Section -->
      @if (isFilterVisible('facility')) {
      <div class="filter-section pt-6">
        <div
          class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
          role="button"
          tabindex="0"
          (click)="toggleFacilityCollapse()"
          (keydown.enter)="toggleFacilityCollapse()"
          (keydown.space)="toggleFacilityCollapse()"
        >
          <h6 class="text-xs font-semibold text-blue-300 m-0">
            Ciudad Ingreso
          </h6>
          <i
            class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
            [class.rotate-180]="isFacilityCollapsed"
          ></i>
        </div>
        @if (!isFacilityCollapsed) {
          @if (!loadingOptions && !optionsError) {
            <div class="flex flex-col items-start gap-2">
              @for (facility of availableFacilities; track facility.code) {
                <app-checkbox-button
                  [label]="facility.name"
                  [checked]="isFacilitySelected(facility.code)"
                  (checkedChange)="onFacilityChange(facility.code, $event)"
                >
                </app-checkbox-button>
              }
            </div>
          }
        }
      </div>
      }

      <!-- Fecha Section -->
      @if (isFilterVisible('dateRange')) {
        <div class="filter-section pt-6">
          <div
            class="flex items-center justify-between cursor-pointer mb-3 pb-3 border-b border-blue-light"
            role="button"
            tabindex="0"
            (click)="toggleDateCollapse()"
            (keydown.enter)="toggleDateCollapse()"
            (keydown.space)="toggleDateCollapse()"
          >
            <h6 class="text-xs font-semibold text-blue-300 m-0">Fecha</h6>
            <i
              class="pi pi-chevron-down text-blue-deep text-xs transition-transform duration-200"
              [class.rotate-180]="isDateCollapsed"
            ></i>
          </div>
          @if (!isDateCollapsed) {
            <div class="flex gap-3 mt-3">
              <div class="flex-1">
                <app-input-date
                  id="fechaInicio"
                  label="Desde"
                  [maxDate]="maxDate"
                  [staticLabel]="true"
                  [(ngModel)]="startDate"
                  (changed)="onStartDateChange($event)"
                >
                </app-input-date>
              </div>
              <div class="flex-1">
                <app-input-date
                  id="fechaFin"
                  label="Hasta"
                  [maxDate]="maxDate"
                  [minDate]="startDate || undefined"
                  [staticLabel]="true"
                  [(ngModel)]="endDate"
                  (changed)="onEndDateChange($event)"
                >
                </app-input-date>
              </div>
            </div>
          }
        </div>
      }
    </div>

    <!-- Footer Actions -->
    <div class="flex justify-between gap-3">
      <app-button
        label="Cancelar"
        [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
        [size]="ButtonSizeEnum.MD"
        (handleClick)="onClose()"
      >
      </app-button>
      <app-button
        label="Guardar"
        [type]="ButtonTypeEnum.PRIMARY"
        [size]="ButtonSizeEnum.MD"
        (handleClick)="onApplyFilters()"
      >
      </app-button>
    </div>
  </aside>
}
